// extracted by mini-css-extract-plugin
export default {"folderName":"DetaillsFolderNames_folderName__ll3bE"};